import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';
import CardSectionAppsItem from './CardSectionAppsItem.vue';
import { AbSlider, AbSliderItem } from '../../../ui';

interface Item {
  image?: string | null;
  name?: string | null;
  text?: string | null;
  link?: string | null;
}

interface Props {
  items?: Item[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionAppsSlider',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
  items?: Item[];
};



const apps = computed<Item[][]>(() => {
  return !props.items
    ? []
    : props.items.reduce((items, item, i) => {
        const chunkIndex = Math.floor(i / 2);

        // eslint-disable-next-line no-param-reassign
        items[chunkIndex] = items[chunkIndex] || [];
        // @ts-ignore
        items[chunkIndex].push(item);

        return items;
      }, []);
});

return { __sfc: true,props, apps, CardSectionAppsItem, AbSlider, AbSliderItem }
}

})